import React from 'react';
import SbEditable from 'storyblok-react';
import accordionActive from '~/icons/accordion-active.svg';
import accordionInactive from '~/icons/accordion-inactive.svg';

function Accordion({ items, activeItem = 0, setActiveItem }) {
  return (
    items &&
    items.map((item, i) => (
      <SbEditable content={item} key={item._uid}>
        <div
          key={`accordionitem${item.heading + i}`}
          className={` cursor-pointer outline-none ${activeItem === i && 'bg-blue'}`}
          onClick={() => activeItem !== i && setActiveItem(i)}
          onKeyPress={() => false}
          role="button"
          tabIndex={i + 1}
        >
          <div className="py-4 px-5 flex-auto flex items-start">
            <img src={activeItem === i ? accordionActive : accordionInactive} alt="" className="mr-3 -mt-1" />
            <div>
              <div className="flex items-center  mb-2">
                <h4 className={`font-extrabold text-20px ${activeItem === i ? 'text-white' : 'text-black underline'} `}>
                  {item.heading}
                </h4>
                <svg
                  className={`ml-4 ${activeItem === i && 'transition duration-150 ease-in-out transform rotate-180'}`}
                  width="13"
                  height="8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask id="a" fill="#fff">
                    <path d="M12.832 7.408L6.862.163.894 7.408" />
                  </mask>
                  <path
                    d="M6.863.163L8.02-.791 6.863-2.196 5.705-.791l1.158.954zm7.127 6.29L8.02-.79 5.705 1.116l5.97 7.246 2.315-1.908zM5.705-.79l-5.97 7.245 2.316 1.908 5.97-7.246L5.704-.79z"
                    fill={activeItem === i ? '#fff' : '#171717'}
                    mask="url(#a)"
                  />
                </svg>
              </div>
              {activeItem === i && (
                <div className="text-white pr-3" dangerouslySetInnerHTML={{ __html: item.content }} />
              )}
            </div>
          </div>
        </div>
      </SbEditable>
    ))
  );
}

export default Accordion;
